import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


export const getHolidaysCompanyList = async (token: string, permission: string | null) => {
    const response = await axios.get(`${API_URL}/presenze/company/holidays/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
        permission,
      } as CustomAxiosRequestConfig);
      return response.data;
  };
  
  export const addHolidayCompany = async (token: string, holidayName: string, day: number, month: number) => {
    const response = await axios.post(`${API_URL}/presenze/company/holidays/`,
      {
        name: holidayName,
        day: day,
        month: month,
      },
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    return response.data;
  }
  
  export const deleteHolidayCompany = async (token: string, id: string) => {
    const response = await axios.delete(`${API_URL}/presenze/company/holidays/${id}`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const updateHolidayCompany = async (token: string, id: string | number,  holidayName: string, day: number, month: number) => {
    const response = await axios.put(`${API_URL}/presenze/company/holidays/${id}/`, 
    {
      name: holidayName,
      day: day,
      month: month,
    }, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
  };
  